import { FacilityService } from './../../../../core/services/facility.service';
import { NonGovermentUniformInvoiceCheckService } from './../../service/non-goverment-uniform-invoice-check.service';
import { DropdownOptionsService } from './../../../../core/services/dropdown-options.service';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { deepCopy, getFacilityByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DatePipe } from '@angular/common';
import { PageInfo } from 'src/app/core/models/page-info';
import { Table } from 'primeng/table';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmEventType } from 'primeng/api';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { startOfDay, endOfDay } from 'date-fns'
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';

@Component({
  selector: 'laas-no-evidence-check',
  templateUrl: './no-evidence-check.component.html',
  styleUrls: ['./no-evidence-check.component.scss']
})
export class NoEvidenceCheckComponent extends SessionBaseComponent implements OnInit {
  isSearchFormOpen: boolean;
  isHeaderLoading: boolean;
  isDetailLoading: boolean;
  canEditTable: boolean;
  isBtnApproveVisible: boolean;
  headerChecked: boolean;
  showUpload: boolean;
  isLoading: boolean;
  isForwarder: boolean;
  searchForm: FormGroup;

  cloneTableValue: any;
  tableValue: any[];
  tableColumns: any[];
  detailTableValue: any[];
  detailTableColumns: any[];
  selectedTableColumns: any[];
  selectedRow: any;
  previousSelectedRow: any;
  selectedRowsWithCheckBox: any[];
  selectedDetailRowsWithCheckBox: any[];
  statusAuthority: any[];

  carrierPaymentByOptions: any[];
  orgIdOptions: any[];
  statusOptions: any[];
  inOutTypeOptions: any[];
  sourceModelOptions: any[];
  currencyOptions: any[];
  invoiceTypeOptions: any[];
  formatTypeOptions: any[];
  paymentMethodOptions: any[];
  termsIdOptions: any[];

  editMode: boolean;

  first: number;
  pageInfo: PageInfo;
  detailPageInfo: PageInfo;
  detailSortInfo: [{ property: string; direction: number }] | null;
  sortInfo: [{ property: string; direction: number }] | null;

  pageDropDownList: number[];

  readonly viewPermissionCode = PermissionConstants.ViewNonGUICheck;
  readonly editPermissionCode = PermissionConstants.EditNonGUICheck;
  currentLang: string = this.laasSetting.language;

  @ViewChild('dataTable') dataTable!: Table;
  @ViewChild('detailDataTable') detailDataTable!: DataTableComponent;
  @ViewChild('guiNoDt') guiNoDt!: CalendarComponent;
  @ViewChild('createDt') createDt!: CalendarComponent;

  constructor(injector: Injector, private formBuilder: FormBuilder, private dropdownOptionsService: DropdownOptionsService, private commonDataService: CommonDataService,
    private datePipe: DatePipe, private nonGovermentUniformInvoiceCheckService: NonGovermentUniformInvoiceCheckService, private facilityService: FacilityService) {
    super(injector);
    this.isSearchFormOpen = true;
    this.isHeaderLoading = false;
    this.isDetailLoading = false;
    this.canEditTable = false;
    this.isBtnApproveVisible = false;
    this.headerChecked = false;
    this.showUpload = false;
    this.isLoading = false;
    this.isForwarder = false;


    this.tableValue = [];
    this.tableColumns = [];
    this.selectedTableColumns = [];
    this.detailTableColumns = [];
    this.detailTableValue = [];
    this.selectedRowsWithCheckBox = [];
    this.selectedDetailRowsWithCheckBox = [];

    this.statusAuthority = ['0', '20', '7', '8'];

    this.carrierPaymentByOptions = [];
    this.orgIdOptions = [];
    this.statusOptions = [];
    this.inOutTypeOptions = [];
    this.sourceModelOptions = [];
    this.currencyOptions = [];
    this.invoiceTypeOptions = [];
    this.formatTypeOptions = [];
    this.paymentMethodOptions = [];
    this.termsIdOptions = [];

    this.editMode = false;

    this.first = 0;
    this.pageInfo = {
      pageSize: 100,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };

    this.detailPageInfo = {
      pageSize: 100,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };
    this.sortInfo = null;
    this.detailSortInfo = null;

    this.pageDropDownList = [100, 300, 500];


    this.searchForm = this.formBuilder.group({
      nonGuiIdStart: null,
      nonGuiIdEnd: null,
      guiNoStart: null,
      guiNoEnd: null,
      guiDtStart: null,
      guiDtEnd: null,
      carrierPaymentBy: null,
      billCorp: null,
      createDtStart: null,
      createDtEnd: null,
      status: null,
      inOutType: null,
      sourceModel: null
    });
    this.previousSelectedRow = this.selectedRow;
  }
  @Input() get selectedColumns(): any[] {
    return this.selectedTableColumns;
  }

  set selectedColumns(cols: any[]) {
    this.selectedTableColumns = this.tableColumns.filter(col => cols.includes(col));
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    // permission Codes
    this.permissionCodes = (
      Object.values(this.userProfile.roles).reduce(
        (c: any, i: any) => c.concat(i.permissions),
        []
      ) as any
    ).map((x: any) => {
      return x.permissionCode;
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'BillingStatus').subscribe({
      next: result => {
        this.tableColumns = this.tableTranslation();
        this.selectedTableColumns = this.tableColumns;
        this.detailTableColumns = this.tableDetailTranslation();
        this.statusOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InOutType').subscribe({
      next: result => {
        this.inOutTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ExpenseInvSourceModel').subscribe({
      next: result => {
        this.sourceModelOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InvoiceType').subscribe({
      next: result => {
        this.invoiceTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'OriginFormatType').subscribe({
      next: result => {
        this.formatTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, '').subscribe({
      next: result => {
        this.orgIdOptions = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityOUCode} - ${x.legalEntityOUName}`,
            value: x.legalEntityOUCode,
          };
        });
      }
    })

    this.dropdownOptionsService.getForwarderOptions()
      .subscribe({
        next: result => {
          this.carrierPaymentByOptions = [...result].map((x: any) => {
            return {
              label: `${x.optionDesc}`,
              value: x.optionCode,
            };
          });
        }
      });

    this.facilityService.getCurrencyOptions()
      .subscribe({
        next: result => {
          this.currencyOptions = [...result].map((x: any) => {
            return {
              label: `${x.optionCode} - ${x.optionDesc}`,
              value: x.optionCode,
            };
          });
        }
      });

    this.facilityService.getExpenseOptions('PaymentMethod', null).subscribe({
      next: result => {
        this.paymentMethodOptions = [...result].map((x: any) => {
          return {
            value: `${x.optionCode}`,
            label: `${x.optionCode}-${x.optionDesc}`,
          };
        });
      }
    });

    this.facilityService.getExpenseOptions('SHT_BILL_ORIGIN.TERMS', null).subscribe({
      next: result => {
        this.termsIdOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode} - ${x.optionDesc}`,
            value: `${x.optionCode}`,
          };
        });
      }
    });

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.viewPermissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.canEditTable = this.permissionCodes.includes(this.editPermissionCode);

    if (this.userProfile.userType == "Forwarder") {
      this.searchForm.get("carrierPaymentBy")?.patchValue(this.userProfile.roles[0].scopes[0].forwarderCode)
      this.isForwarder = true;
    }

    if (this.userProfile.userType === UserType.SuperAdmin.toString() ||
        this.permissionCodes.includes(PermissionConstants.BtnApproveNonGUI)) {
      this.isBtnApproveVisible = true;
    }
  }

  searchBtnClick() {
    if (this.notSaveConfirm()) {
      this.confirmationService.confirm({
        message: this.translateService.instant('NoEvidenceCheck.Confirm.SaveOrNot'),
        header: this.translateService.instant('NoEvidenceCheck.Confirm.Header'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.saveChange();
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              this.resetPageInfo();
              this.doSearch();
              break;
            case ConfirmEventType.CANCEL:
              break;
          }
        }
      })
    } else {
      this.dataTable.cancelRowEdit(this.selectedRow);
      this.editMode = false;
      this.resetPageInfo();
      this.doSearch();
    }
  }

  resetBtnClick() {
    if (this.isForwarder) {
      const forwarderCode = this.searchForm.get("carrierPaymentBy")?.value;
      this.searchForm.reset()
      this.searchForm.get("carrierPaymentBy")?.patchValue(forwarderCode);
    } else {
      this.searchForm.reset()
    }
    this.createDt.ngOnInit();
    this.guiNoDt.ngOnInit();
  }

  doSearch() {
    this.isHeaderLoading = true;
    let request = deepCopy(this.searchForm.value);
    request.facility = this.laasSetting.facility;
    request.userId = this.userProfile.userName;
    request.userUUID = this.userProfile.uuid;
    request.userType = this.userProfile.userType;
    request.authToken = this.authenticationService.currentToken;
    request.pageSize = this.pageInfo.pageSize;
    request.pageIndex = this.pageInfo.pageIndex;
    request.sortInfo = this.sortInfo;
    request.facilityList = getFacilityByPermission(this.userProfile, "ViewNonGUICheck");
    console.log("param：",request);
    this.nonGovermentUniformInvoiceCheckService.searchNonGovermentInvoice(request).subscribe({
      next: result => {
        const pageList = result.content;
        this.tableValue = pageList;
        this.putRowId(this.tableValue);
        console.log(this.tableValue)
        // 日期轉換
        for (const row of this.tableValue) {
          if (!isNullOrEmpty(row.guiDt)) {
            row.guiDt = new Date(row.guiDt);
          }
        }
        this.cloneTableValue = deepCopy(this.tableValue);

        //更改總數量資料
        this.pageInfo.totalRecords = result.totalElements;
        if (this.pageInfo.totalRecords > 500) {
          if (this.pageDropDownList.length == 4) {
            this.pageDropDownList[3] = this.pageInfo.totalRecords
          } else {
            this.pageDropDownList.push(this.pageInfo.totalRecords);
          }
        } else {
          this.pageDropDownList = [100, 300, 500];
        }

        // 重新抓取資料後取消編輯
        this.selectedRow = this.tableValue[0]
        this.doSearchDetailData()
        this.dataTable.cancelRowEdit(this.previousSelectedRow);
        this.editMode = false;

        this.isHeaderLoading = false;
        this.isSearchFormOpen = false;
        this.headerChecked = false;
        this.selectedRowsWithCheckBox = [];
      }
    })
  }

  putRowId(array: any[]) {
    let rowId = 1;
    for (const val of array) {
      val.rowId = rowId;
      rowId = rowId + 1;
    }
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.doSearch();
  }

  tableSort(event: any): void {
    this.resetPageInfo();
    this.sortInfo = [{ property: event.field, direction: event.order }];
    this.doSearch();
  }
  detailTablePageChange(event: any) {
    this.detailPageInfo.pageSize = event.rows;
    this.detailPageInfo.pageIndex = event.first / this.detailPageInfo.pageSize;
    this.doSearchDetailData();
  }

  detailTableSort(event: any): void {
    this.detailPageInfo = {
      pageSize: 100,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };
    this.detailSortInfo = [{ property: event.field, direction: event.order }];
    this.doSearchDetailData();
  }

  onRowClick(rowData: any) {
    this.selectedRow = rowData;
    if (this.editMode) {
      this.doSwitchRow()
    }
  }

  doSwitchRow() {
    this.dataTable.cancelRowEdit(this.previousSelectedRow);

    if (this.statusAuthority.includes(this.selectedRow.status)) {
      this.dataTable.initRowEdit(this.selectedRow);
    }
    this.previousSelectedRow = deepCopy(this.selectedRow);

  }

  doSearchDetailData() {
    if (this.selectedRow) {
      this.isDetailLoading = true;
      let request = {
        nonGuiId: this.selectedRow.nonGuiId,
        pageSize: this.detailPageInfo.pageSize,
        pageIndex: this.detailPageInfo.pageIndex,
        sortInfo: this.detailSortInfo
      }

      this.nonGovermentUniformInvoiceCheckService.searchNonGovermentInvoiceDetail(request).subscribe({
        next: result => {
          const pageList = result.content;
          // gen dataKey
          pageList.forEach((item: any, index: number) => item.index = index);
          this.detailTableValue = pageList;

          //更改總數量資料
          this.detailPageInfo.totalRecords = result.totalElements;
          this.isDetailLoading = false;
        }
      })
    }
  }

  switchEditMode() {
    if (this.editMode) {
      if (this.notSaveConfirm()) {
        this.confirmationService.confirm({
          message: this.translateService.instant('NoEvidenceCheck.Confirm.SaveOrNot'),
          header: this.translateService.instant('NoEvidenceCheck.Confirm.Header'),
          icon: 'pi pi-info-circle',
          accept: () => {
            this.saveChange();
          },
          reject: (type: any) => {
            switch (type) {
              case ConfirmEventType.REJECT:
                this.dataTable.cancelRowEdit(this.selectedRow);
                this.editMode = false;
                break;
              case ConfirmEventType.CANCEL:
                break;
            }
          }
        })
      } else {
        this.dataTable.cancelRowEdit(this.selectedRow);
        this.editMode = false;
      }
    } else if (this.selectedRow) {

      this.doSwitchRow();
      this.editMode = true;
    }
  }
  saveBtnClick() {
    this.confirmationService.confirm({
      message: this.translateService.instant('NoEvidenceCheck.Confirm.Save'),
      header: this.translateService.instant('NoEvidenceCheck.Confirm.Header'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.saveChange();
      }
    })
  }

  async saveChange() {
    this.isHeaderLoading = true;
    let updateDataArr = [];
    var errorGuiNoList = [];

    for (const rowVal of this.tableValue) {
      for (const cloneRowVal of this.cloneTableValue) {
        if (rowVal.rowId == cloneRowVal.rowId) {
          if (JSON.stringify(rowVal) != JSON.stringify(cloneRowVal)) {
            if (rowVal.guiNo.length > 30) {
              errorGuiNoList.push(rowVal.guiNo);
              break;
            }
            const updateData = {
              nonGuiId: rowVal.nonGuiId, guiAmount: rowVal.guiAmount, guiNo: rowVal.guiNo,
              guiDt: rowVal.guiDt, guiCurrency: rowVal.guiCurrency, shippingDescription: rowVal.shippingDescription,
              amountDifferenceDescription: rowVal.amountDifferenceDescription, updateUser: this.userProfile.userName
            }
            updateDataArr.push(updateData);
          }
        }
      }
    }

    if (errorGuiNoList.length > 0) {
      const instantMsg = await this.translateService.get("EvidenceCheck.Message.GuiNoMaxLength").toPromise();
      this.toastErrorMessage(instantMsg);
      this.isHeaderLoading = false;
      return;
    }

    this.nonGovermentUniformInvoiceCheckService.updateNonGovermentUniformInvoice(updateDataArr).subscribe({
      next: result => {
        this.doSearch();
        this.toastService.success(this.translateService.instant('NoEvidenceCheck.Toast.SaveSuccess'))
      },
      error: (err: HttpErrorResponse) => {
        this.toastService.error(err.error);
        this.isHeaderLoading = false;
      },
      complete: () => {
        this.isHeaderLoading = false;
      }
    })
  }

  notSaveConfirm(): boolean {
    if (this.editMode) {
      for (const rowVal of this.tableValue) {
        for (const cloneRowVal of this.cloneTableValue) {
          if (rowVal.rowId == cloneRowVal.rowId) {
            if (JSON.stringify(rowVal) != JSON.stringify(cloneRowVal)) {
              return true;
            }
          }
        }
      }
      return false;
    } else {
      return false;
    }
  }

  getDetailRowSum() {
    let amountSum = 0;
    let estimatedAmountSum = 0;

    for (const row of this.selectedDetailRowsWithCheckBox) {
      amountSum = amountSum + row.amount;
      estimatedAmountSum = estimatedAmountSum + row.estimatedAmount;
    }

    return { amount: amountSum, estimatedAmount: estimatedAmountSum };
  }

  getHeaderRowSum() {
    let amountSum = 0;

    for (const row of this.selectedRowsWithCheckBox) {
      if (isNullOrEmpty(row.amount)) {
        amountSum = amountSum + 0;
      } else {
        amountSum = amountSum + parseFloat(row.amount);
      }
    }
    return { amount: amountSum };
  }

  resetPageInfo() {
    this.pageInfo = {
      pageSize: this.dataTable.rows ?? 100,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };
    this.first = 0;
  }

  // translate table
  tableTranslation(): any[] {

    var fields: string[];
    var jsons: string[];
    var tmpcolumn: any[] = [];

    fields = ['nonGuiId', 'billCorp', 'setOfBooksId', 'carrierPaymentBy', 'status', 'guiAmount', 'amount', 'guiNo',
      'guiDt', 'guiCurrency', 'shippingDescription', 'amountDifferenceDescription',
      'erpCarrierPaymentSiteId', 'termsId', 'paymentMethod', 'glDt', 'createUser', 'createDt', 'updateUser', 'updateDt',
      'sourceModel', 'amountDifferenceColorFlag'];
    jsons = [
      'NoEvidenceCheck.Table.Columns.NonGUIId', 'NoEvidenceCheck.Table.Columns.OrgId', 'NoEvidenceCheck.Table.Columns.SetOfBooksId', 'NoEvidenceCheck.Table.Columns.CarrierPaymentBy',
      'NoEvidenceCheck.Table.Columns.Status', 'NoEvidenceCheck.Table.Columns.GUIAmount', 'NoEvidenceCheck.Table.Columns.Amount','NoEvidenceCheck.Table.Columns.GUINo',
      'NoEvidenceCheck.Table.Columns.GUIDt', 'NoEvidenceCheck.Table.Columns.GUICurrency', 'NoEvidenceCheck.Table.Columns.ShippingDescription',
      'NoEvidenceCheck.Table.Columns.AmountDifferenceDescription', 'NoEvidenceCheck.Table.Columns.ERPCarrierPaymentSiteId', 'NoEvidenceCheck.Table.Columns.TermsId',
      'NoEvidenceCheck.Table.Columns.PaymentMethod', 'NoEvidenceCheck.Table.Columns.GLDt', 'Common.Label.CreateUser',
      'Common.Label.CreateDate', 'Common.Label.UpdateUser', 'Common.Label.UpdateDate',
      'NoEvidenceCheck.Table.Columns.SourceModel', 'NoEvidenceCheck.Table.Columns.AmountDifferenceColorFlag'];

    for (let i = 0; i < fields.length; i++) {
      this.translateService.get(jsons[i])
        .subscribe((translation: string) => {
          //建立日期 || 更新時間
          if (i == 8 || i == 15 || i == 17 || i == 19) {
            tmpcolumn[i] = ({ field: fields[i], header: translation, dataType: 'date', sort: true })
          }
          else {
            tmpcolumn[i] = ({ field: fields[i], header: translation, sort: true })
          }
        });
    }
    return tmpcolumn;

  }

  tableDetailTranslation(): any[] {

    var fields: string[];
    var jsons: string[];
    var tmpcolumn: any[] = [];

    fields = ['invoiceType', 'accountName', 'nonGuiId', 'estimatedAmount', 'amount', 'linePayCurrency', 'linePayAmount',
      'linePayRate', 'expressBill', 'importDeclarationNo', 'description',
      'salerNo', 'salerName', 'formatType', 'taxCode', 'vatCode', 'guiTaxAmount', 'linePayRateAf', 'guiAmountWithoutTax',
      'lineDescription', 'createUser', 'createDt', 'updateUser', 'updateDt', 'lineBaseCurrency', 'lineBaseAmount',
      'payBaseAmount', 'cutCode'];
    jsons = [
      'NoEvidenceCheck.DetailTable.Columns.InvoiceType', 'NoEvidenceCheck.DetailTable.Columns.AccountName', 'NoEvidenceCheck.DetailTable.Columns.NonGUIId',
      'NoEvidenceCheck.DetailTable.Columns.EstimatedAmount',
      'NoEvidenceCheck.DetailTable.Columns.Amount', 'NoEvidenceCheck.DetailTable.Columns.LinePayCurrency', 'NoEvidenceCheck.DetailTable.Columns.LinePayAmount',
      'NoEvidenceCheck.DetailTable.Columns.LinePayRate', 'NoEvidenceCheck.DetailTable.Columns.ExpressBill', 'NoEvidenceCheck.DetailTable.Columns.ImportDeclarationNo',
      'NoEvidenceCheck.DetailTable.Columns.Description', 'NoEvidenceCheck.DetailTable.Columns.SalerNo', 'NoEvidenceCheck.DetailTable.Columns.SalerName',
      'NoEvidenceCheck.DetailTable.Columns.FormatType', 'NoEvidenceCheck.DetailTable.Columns.TaxCode', 'NoEvidenceCheck.DetailTable.Columns.VatCode',
      'NoEvidenceCheck.DetailTable.Columns.GuiTaxAmount', 'NoEvidenceCheck.DetailTable.Columns.LinePayRateAf', 'NoEvidenceCheck.DetailTable.Columns.GuiAmountWithoutTax',
      'NoEvidenceCheck.DetailTable.Columns.LineDescription', 'Common.Label.CreateUser', 'Common.Label.CreateDate',
      'Common.Label.UpdateUser', 'Common.Label.UpdateDate', 'NoEvidenceCheck.DetailTable.Columns.LineBaseCurrency',
      'NoEvidenceCheck.DetailTable.Columns.LineBaseAmount', 'NoEvidenceCheck.DetailTable.Columns.PayBaseAmount', 'NoEvidenceCheck.DetailTable.Columns.CutCode'];

    for (let i = 0; i < fields.length; i++) {
      this.translateService.get(jsons[i])
        .subscribe((translation: string) => {
          //建立日期 || 更新時間
          if (i == 21 || i == 23) {
            tmpcolumn[i] = ({ field: fields[i], header: translation, dataType: 'date', sort: true })
          }
          else {
            tmpcolumn[i] = ({ field: fields[i], header: translation, sort: true })
          }
        });
    }
    return tmpcolumn;

  }


  nonGovermentUniformInvoiceExcelBtn(): void {
    console.log("this.pageInfo.totalRecords:",this.pageInfo.totalRecords);
    if(this.pageInfo.totalRecords == 0){
      this.toastService.info(this.translateService.instant('NoEvidenceCheck.TickInformation'));
      return;
    }
    if (this.selectedRowsWithCheckBox.length == 0) {
      let request = deepCopy(this.searchForm.value);
      request.facility = this.laasSetting.facility;
      request.userId = this.userProfile.userName;
      request.userUUID = this.userProfile.uuid;
      request.userType = this.userProfile.userType;
      request.authToken = this.authenticationService.currentToken;
      request.pageSize = this.pageInfo.totalRecords;
      request.pageIndex = 0;
      request.sortInfo = this.sortInfo;
      request.facilityList = getFacilityByPermission(this.userProfile, "ViewNonGUICheck");
      this.nonGovermentUniformInvoiceCheckService.searchNonGovermentInvoice(request).subscribe({
        next: (result) => {
          let nonGuiId = result.content.map((a: { nonGuiId: any; }) => a.nonGuiId);
          this.getNonGovermentUniformInvoiceExcel(nonGuiId);
        },
      });
    }else{
      var nonGuiIds = this.selectedRowsWithCheckBox.map(a => a.nonGuiId);
      this.getNonGovermentUniformInvoiceExcel(nonGuiIds);
    }
  }

  getNonGovermentUniformInvoiceExcel(nonGuiIds : any[]){

    let params = {
      facility: this.laasSetting.facility,
      nonGuiIds: nonGuiIds
    };

    this.loader.show();
    let fileDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.nonGovermentUniformInvoiceCheckService.getNonGovermentUniformInvoiceExcel(params).subscribe({
      next: result => {
        if (result == null || result.size == 0) {
          this.toastService.info(this.translateService.instant('NoEvidenceCheck.NoFound'));
        } else {
          const file = result;
          file.name = fileDate + "_無憑下載";
          const url = URL.createObjectURL(file);
          let a: any = document.createElement('a');
          a.href = url
          a.download = file.name;
          a.click();
          URL.revokeObjectURL(url);
        }
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    })

  }




  uploadClickBtn(): void {
    this.showUpload = true;
  }

  approveBtnClick(): void {
    const updateObj = {
      nonGuiIds: this.selectedRowsWithCheckBox.map(x => x.nonGuiId),
      updateUser: this.userProfile.userName
    };
    this.isDetailLoading = true;
    this.isHeaderLoading = true;


    this.nonGovermentUniformInvoiceCheckService.approveNonGovermentUniformInvoice(updateObj).subscribe({
      next: result => {
        this.toastService.success(this.translateService.instant('NoEvidenceCheck.ApprovedSuccess'));
        this.searchBtnClick();
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.isDetailLoading = false;
        this.isHeaderLoading = false;
      }
    });
  }

  addBtnClick(): void {
    this.isDetailLoading = true;
    this.isHeaderLoading = true;
    const updateObj = {
      nonGuiIds: this.selectedRowsWithCheckBox.map(x => x.nonGuiId),
      updateUser: this.userProfile.userName,
      employeeCode: this.userProfile.employCode
    };
    console.log(updateObj);

    this.nonGovermentUniformInvoiceCheckService.addNonGovermentUniformInvoice(updateObj).subscribe({
      next: result => {
        if (isNullOrEmpty(result.errorMessage)) {
          this.toastService.success(this.translateService.instant('NoEvidenceCheck.ApplicationSuccess'));
          this.searchBtnClick();
        } else {
          this.toastErrorMessage(result.errorMessage);
          this.isDetailLoading = false;
          this.isHeaderLoading = false;
        }
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.isDetailLoading = false;
        this.isHeaderLoading = false;
      }
    });
  }

  rejectBtnClick(): void {
    this.isDetailLoading = true;
    this.isHeaderLoading = true;
    const updateObj = {
      nonGuiIds: this.selectedRowsWithCheckBox.map(x => x.nonGuiId),
      updateUser: this.userProfile.userName
    };

    this.nonGovermentUniformInvoiceCheckService.rejectNonGovermentUniformInvoice(updateObj).subscribe({
      next: result => {
        this.toastService.success(this.translateService.instant('NoEvidenceCheck.ReturnSuccess'));
        this.searchBtnClick();
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.isDetailLoading = false;
        this.isHeaderLoading = false;
      }
    });
  }

  fileUploader(event: any): void {

    if (event.files[0]) {
      console.log('true');
    } else {
      console.log('false');
    }
    this.nonGovermentUniformInvoiceCheckService.importNonGovermentUniformInvoiceByExcel(event.files[0],
      this.laasSetting.facility, this.userProfile.userName).subscribe({
        next: rsp => {
          this.isLoading = false;
          this.toastService.success(this.translateService.instant('NoEvidenceCheck.UploadSuccess'), false);
        },
        error: (err: HttpErrorResponse) => {
          console.log(err);
          this.isLoading = false;
          this.toastService.error(`${err.error.errorCode} ${err.error.errorMsg}`);
        },
      });
  }

  selectAllOrUnSelectAll(event: any) {
    if (this.headerChecked) {
      this.selectedRowsWithCheckBox = this.tableValue
    } else {
      this.selectedRowsWithCheckBox = []
    }
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'guiNoDt':
        this.searchForm.get('guiDtStart')?.setValue(startOfDay(date.startDate));
        this.searchForm.get('guiDtEnd')?.setValue(startOfDay(date.endDate));
        break;
      case 'createDt':
        this.searchForm.get('createDtStart')?.setValue(startOfDay(date.startDate));
        this.searchForm.get('createDtEnd')?.setValue(startOfDay(date.endDate));
        break;
    }
  }



}
